module.exports = __webpack_public_path__ + "static/media/gameplay_bg_b_05.73bef710.png";